angular.module('about.routes', [
  'ui.router'
]).config(function config($stateProvider) {
  $stateProvider.state('about', {
    url: '/contact-us',
    controller: 'AboutCtrl',
    templateUrl: 'components/about/about.html'
  });
})
